/**
 * 微信 OAuth 落地页等：不依赖登录态，401 也不应踢回登录页
 */
export const WECHAT_BINDING_PUBLIC_PATHS = [
  '/wechat-binding/authorize-page',
  '/wechat-binding/callback',
] as const;

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  if (pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '') || '/';
}

export function isWechatBindingPublicPath(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return (WECHAT_BINDING_PUBLIC_PATHS as readonly string[]).includes(p);
}

/**
 * 浏览器端兜底：微信内置浏览器等环境下 pathname 偶发异常时，用路径片段判断
 */
export function isWechatBindingPublicContext(): boolean {
  if (typeof window === 'undefined') return false;
  const p = normalizePathname(window.location.pathname);
  if (isWechatBindingPublicPath(p)) return true;
  if (p.endsWith('/wechat-binding/authorize-page') || p.endsWith('/wechat-binding/callback')) {
    return true;
  }
  if (
    p.includes('/wechat-binding/authorize-page') ||
    p.includes('/wechat-binding/callback')
  ) {
    return true;
  }
  return false;
}

/** 任意来源的 pathname + 浏览器兜底 */
export function isWechatBindingPublicRoute(pathname: string | undefined): boolean {
  if (pathname && isWechatBindingPublicPath(pathname)) return true;
  return isWechatBindingPublicContext();
}
